import { useEffect, useState } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// Trimestre que se está viendo en Salientes, Proformas o Entrantes. No se guarda
// con los filtros: cada pantalla abre siempre en el trimestre actual. Mientras
// se trabaja queda en memoria, para no perderlo al abrir un documento y volver a
// la lista (con la flecha del navegador o con `state: { volverALaLista: true }`);
// se pierde al entrar por el menú y al recargar la página.
const elegidos = new Map();

const trimestreActual = () => {
  const hoy = new Date();
  return { year: hoy.getFullYear(), quarter: Math.floor(hoy.getMonth() / 3) + 1 };
};

// `ambito`: lo que comparte el trimestre elegido, como lo compartían al
// guardarse con los filtros (Salientes y Proformas uno; Entrantes otro).
const useTrimestreDeTrabajo = (ambito) => {
  const location = useLocation();
  const tipoDeNavegacion = useNavigationType();
  const vuelveALaLista = tipoDeNavegacion === 'POP' || location.state?.volverALaLista === true;
  const [periodo, setPeriodo] = useState(() => (vuelveALaLista && elegidos.get(ambito)) || trimestreActual());

  // Pulsar el menú de la pantalla en la que ya se está, o pasar de Salientes a
  // Proformas, no vuelve a montar el componente.
  useEffect(() => {
    if (!vuelveALaLista) setPeriodo(trimestreActual());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key]);

  useEffect(() => {
    elegidos.set(ambito, periodo);
  }, [ambito, periodo]);

  return {
    year: periodo.year,
    quarter: periodo.quarter,
    setYear: (year) => setPeriodo((actual) => ({ ...actual, year })),
    setQuarter: (quarter) => setPeriodo((actual) => ({ ...actual, quarter })),
  };
};

export default useTrimestreDeTrabajo;
